export default __webpack_public_path__ + "static/static-asset-smartyNavOpen-545ea3b41878f96b5f831663b2735b43.svg";